import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWorkspaceLocationsByWorkspaceIdQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['Int']['input'];
}>;


export type GetWorkspaceLocationsByWorkspaceIdQuery = { __typename?: 'query_root', workspaceLocations: Array<{ __typename?: 'workspaceLocations', id: number, name: string, abbreviation?: string | null, active: boolean, city?: string | null, state?: string | null }> };


export const GetWorkspaceLocationsByWorkspaceIdDocument = gql`
    query getWorkspaceLocationsByWorkspaceId($workspaceId: Int!) {
  workspaceLocations(where: {workspaceId: {_eq: $workspaceId}}) {
    id
    name
    abbreviation
    active
    city
    state
  }
}
    `;

/**
 * __useGetWorkspaceLocationsByWorkspaceIdQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceLocationsByWorkspaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceLocationsByWorkspaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceLocationsByWorkspaceIdQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceLocationsByWorkspaceIdQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceLocationsByWorkspaceIdQuery, GetWorkspaceLocationsByWorkspaceIdQueryVariables> & ({ variables: GetWorkspaceLocationsByWorkspaceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceLocationsByWorkspaceIdQuery, GetWorkspaceLocationsByWorkspaceIdQueryVariables>(GetWorkspaceLocationsByWorkspaceIdDocument, options);
      }
export function useGetWorkspaceLocationsByWorkspaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceLocationsByWorkspaceIdQuery, GetWorkspaceLocationsByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceLocationsByWorkspaceIdQuery, GetWorkspaceLocationsByWorkspaceIdQueryVariables>(GetWorkspaceLocationsByWorkspaceIdDocument, options);
        }
export function useGetWorkspaceLocationsByWorkspaceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceLocationsByWorkspaceIdQuery, GetWorkspaceLocationsByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceLocationsByWorkspaceIdQuery, GetWorkspaceLocationsByWorkspaceIdQueryVariables>(GetWorkspaceLocationsByWorkspaceIdDocument, options);
        }
export type GetWorkspaceLocationsByWorkspaceIdQueryHookResult = ReturnType<typeof useGetWorkspaceLocationsByWorkspaceIdQuery>;
export type GetWorkspaceLocationsByWorkspaceIdLazyQueryHookResult = ReturnType<typeof useGetWorkspaceLocationsByWorkspaceIdLazyQuery>;
export type GetWorkspaceLocationsByWorkspaceIdSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceLocationsByWorkspaceIdSuspenseQuery>;
export type GetWorkspaceLocationsByWorkspaceIdQueryResult = Apollo.QueryResult<GetWorkspaceLocationsByWorkspaceIdQuery, GetWorkspaceLocationsByWorkspaceIdQueryVariables>;